import {
  deletePlan,
  getContractPlans,
  storeContractPlan
} from "../../api-helpers/contracts/api-plans";

export default {
  state: {
    isGettingContractPlans: false,
    contractPlans: null,
    isStoringContractPlan: false,
    isDeletingPlan: false
  },
  mutations: {
    setIsGettingContractPlans(state, bool) {
      state.isGettingPlans = bool;
    },
    setContractPlans(state, plans) {
      state.contractPlans = plans;
    },
    setIsStoringContractPlan(state, bool) {
      state.isStoringContractPlan = bool;
    },
    setIsDeletingPlan(state, bool) {
      state.isDeletingPlan = bool;
    }
  },
  actions: {
    async getContractPlans({ state, commit }, contractId) {
      let plans = state.plans;
      if (!state.isGettingContractPlans && contractId) {
        commit("setIsGettingContractPlans", true);

        plans = await getContractPlans(contractId);
        commit("setContractPlans", plans);

        commit("setIsGettingContractPlans", false);
      }
      return plans;
    },
    async storeContractPlan({ state, commit, dispatch }, data) {
      let response;
      if (
        !state.isStoringContractPlan &&
        data &&
        data.contractId &&
        data.plan
      ) {
        commit("setIsStoringContractPlan", true);

        response = await storeContractPlan(data.contractId, data.plan);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Plan stored successfully.",
          errorText: "An error occurred while attempting to store Plan.",
          afterSuccessFunction: () => {
            dispatch("getContractPlans", data.contractId);
          }
        });

        commit("setIsStoringContractPlan", false);
      }
      return response;
    },
    async deletePlan({ state, commit, dispatch }, plan) {
      let response;
      if (!state.isDeletingPlan && plan) {
        commit("setIsDeletingPlan", true);

        response = await deletePlan(plan);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Plan deleted successfully.",
          errorText: "An error occurred while attempting to delete Plan.",
          afterSuccessFunction: () => {
            dispatch("getContractPlans", plan.contract_id);
          }
        });

        commit("setIsDeletingPlan", false);
      }
      return response;
    }
  }
};
